<svg:defs xmlns="http://www.w3.org/2000/svg">
    <filter height="130%" id="dropshadow">
        <feOffset result="offOut" in="SourceAlpha" dx="0" dy="0"></feOffset>
        <feGaussianBlur result="blurOut" in="offOut" stdDeviation="5"></feGaussianBlur>
        <feBlend in="SourceGraphic" in2="blurOut" mode="normal"></feBlend>
    </filter>
</svg:defs>

<svg:g class="pie">
    <svg:g (mouseleave)="hoveredIndex=-1">
        <!-- Hairline separators in the surface colour give the slices a crisp, set-apart read. -->
        <svg:g *ngFor="let arc of arcs;let i=index" class="arc" (mouseover)="hoveredIndex=i">
            <svg:path [attr.fill]="arc.color || '#07a'"
                      [attr.d]="arc.path"
                      stroke="var(--cs-surface, #fff)"
                      [attr.stroke-width]="hoveredIndex === i ? '2.5' : '1.5'"
                      stroke-linejoin="round"
                      container="body" ngbPopover="{{arc.valueText+' ('+arc.percentage+'%)'}}" triggers="mouseenter:mouseleave" popoverTitle="{{arc.label }}">
            </svg:path>
        </svg:g>
        <svg:g *ngIf="hoveredIndex>-1" class="arc hover">
            <svg:path filter="url(#dropshadow)" [attr.fill]="arcs[hoveredIndex].color || '#07a'" [attr.d]="arcs[hoveredIndex].path"
                stroke="var(--cs-surface, #fff)" stroke-width="2.5" stroke-linejoin="round"
                container="body" ngbPopover="{{arcs[hoveredIndex].valueText+' ('+arcs[hoveredIndex].percentage+'%)'}}"
                triggers="mouseenter:mouseleave" popoverTitle="{{arcs[hoveredIndex].label }}">
            </svg:path>
        </svg:g>
    </svg:g>
    <svg:g *ngIf="config.type === 'donut'" class="donut">
        <svg:circle [attr.cx]="center?.X" [attr.cy]="center?.Y" [attr.r]="radius*0.7" fill="var(--cs-surface, #fff)"></svg:circle>
    </svg:g>
</svg:g>

<!-- Legend: compact editorial rows — dot swatch, label in ink, value muted underneath.
     Row height is sized so a 5-6 item legend fits the default chart height without clipping. -->
<svg:svg class="legend-container" *ngIf="config.showLegend" x="70%" y="14" height="100%" (mouseleave)="hoveredIndex=-1">
    <svg:g *ngFor="let arc of arcs;let i=index" text-anchor="start" (mouseover)="hoveredIndex=i" [attr.class]="hoveredIndex === i? 'legend hover':'legend'">
        <circle cx="6" [attr.cy]="i*38 + 7" r="5" [attr.fill]="arc.color"></circle>
        <text x="18" [attr.y]="i*38 + 11" fill="currentColor" fill-opacity="0.9" font-size="11.5" font-weight="600">
            {{arc.label}}
        </text>
        <text x="18" [attr.y]="i*38 + 26" fill="currentColor" fill-opacity="0.55" font-size="11">
            {{arc.valueText + ' (' + arc.percentage + '%)'}}
        </text>
        <rect x="0" [attr.y]="i*38 - 4" width="100%" height="36" fill="white" fill-opacity="0" (mouseover)="hoveredIndex=i"></rect>
    </svg:g>
</svg:svg>
